import { Controller } from "@hotwired/stimulus"

// Attendee counter in the registrants list header. It shows the total returned
// by the server after a `remote-toggle` checkbox is saved, without reloading.
export default class extends Controller {
  actualiza ({ detail }) {
    const total = detail?.total_asistentes
    if (Number.isInteger(total)) this.element.textContent = total
  }
}
